console.log('yes it is ....')
let mapSelector = document.querySelector('#store_map')
mapSelector.addEventListener('change', function() {
    console.log('yes it is changed ....')
    if(this.value == 'omni_maps') {
        if(!window.location.href.includes('view=omni-locations')) {
            window.location.href = 'https://steelsupplements.com/pages/store-locations?view=omni-locations'
        }
    }else if (this.value == 'revit_maps'){
        if(!window.location.href.includes('view=steel-locations')) {
            window.location.href = 'https://steelsupplements.com/pages/store-locations?view=revit-locations'
        }
    }else {
        if(!window.location.href.includes('view=steel-locations')) {
            window.location.href = 'https://steelsupplements.com/pages/store-locations?view=steel-locations'
        }
    }
})
const mapsShown = () => {
    if(
        window.location.href.includes('view=omni-locations') ||
        window.location.href.includes('view=steel-locations') || 
        window.location.href.includes('view=revit-locations')) {
        window.scrollTo(0, document.querySelector('.main-page-title').offsetTop - 90);
    }
}
mapsShown()